import type { Secret } from "@p0security/shared/vault/types";
import { useState } from "react";

import { useGuardedEffect } from "../../hooks/useGuardedEffect.ts";
import { useAuthFetch } from "../Login/hook.ts";

export type VaultData = Omit<Secret, "latest"> & {
  createdOn?: string;
};

export const useVault = () => {
  const [error, setError] = useState<string>();
  const [vault, setVault] = useState<{
    projectId: string;
    vault: VaultData[];
  }>();
  const [vaultLoading, setVaultLoading] = useState(true);
  const authFetch = useAuthFetch();

  useGuardedEffect(
    (cancellation) => async () => {
      setVaultLoading(true);
      const response = await authFetch("vault/", {});
      if (!response?.ok || cancellation.isCancelled) return;
      const { projectId, vault } = await response.json();

      setVault({
        projectId,
        vault: vault.map((v: Secret) => {
          const name = v.name.split("/").at(-1);
          return {
            ...v,
            name,
            createdOn: v.latest?.createTime,
          };
        }),
      });
      setVaultLoading(false);
    },
    [authFetch],
    setError
  );

  return { error, vault, vaultLoading };
};
